import React from "react";

function Notification(props) {
  return (
    <span>
      <svg
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5276 4.00125C11.9763 4.00125 8.27756 7.7 8.27756 12.2513V16.225C8.27756 17.0638 7.92006 18.3425 7.49381 19.0575L5.91256 21.6838C4.93631 23.3063 5.61006 25.1075 7.39756 25.7125C13.3238 27.6925 19.7176 27.6925 25.6438 25.7125C27.3076 25.1625 28.0363 23.1963 27.1288 21.6838L25.5476 19.0575C25.1351 18.3425 24.7776 17.0638 24.7776 16.225V12.2513C24.7776 7.71375 21.0651 4.00125 16.5276 4.00125Z"
          stroke="#1E1E1E"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M19.0711 4.40001C18.6449 4.27626 18.2049 4.18001 17.7511 4.12501C16.4311 3.96001 15.1661 4.05626 13.9836 4.40001C14.3824 3.38251 15.3724 2.66751 16.5274 2.66751C17.6824 2.66751 18.6724 3.38251 19.0711 4.40001Z"
          stroke="#1E1E1E"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.6526 26.2075C20.6526 28.4762 18.7963 30.3325 16.5276 30.3325C15.4001 30.3325 14.3551 29.865 13.6126 29.1225C12.8701 28.38 12.4026 27.335 12.4026 26.2075"
          stroke="#1E1E1E"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
      </svg>
    </span>
  );
}

export default Notification;
